// The one answer to "is astra_popular_questions on for this account" (#5258).
// The nav, the Playbook redirect, the Connect prompts and signed-in Astra's
// shelf all ask here, so they never disagree. The server re-checks the
// account's verified token on /astra-popular; this only decides what draws.
import { useAuth } from '../context/AuthContext';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import { ASTRA_POPULAR_QUESTIONS } from '../config/featureFlags';

/** Pure: {on, ready} from the flags context's values. `ready` is false until
 *  this account's own read answered (a stale signed-out read is not its answer). */
export function popularQuestionsState({ flags, ready, forEmail } = {}, currentUser = null) {
    const mine = Boolean(currentUser) && forEmail === currentUser.email;
    return { on: mine && Boolean(flags?.[ASTRA_POPULAR_QUESTIONS]), ready: !currentUser || (Boolean(ready) && mine) };
}

export default function usePopularQuestions() {
    const { currentUser } = useAuth() || {};
    const ff = useFeatureFlags({ mine: true, public: false }) || {};
    return popularQuestionsState(ff, currentUser);
}
